import React, { ChangeEvent, useEffect, useMemo, useState } from "react";
import styles from "./index.module.css";
import {
  Button,
  CircularProgress,
  createStyles,
  Grid,
  IconButton,
  InputBase,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  withStyles,
  TableContainer,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Dialog,
  makeStyles,
  Theme,
  FormControl,
  Select
} from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import { Field, FieldProps, Form, Formik } from "formik";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  AccountType,
  CustomerType,
  CustomerVerificationStatus,
  IBusinessCustomerApprovedDriverInput,
  ICustomer,
  ICustomerDocument,
  UserRole,
} from "../../reducers/auth/types";
import { useHistory } from "react-router-dom";
import { DateTime as d } from "luxon";
import { getSignedUrl } from "../../utils/getSignedUrl";
import { useSnackBar } from "../SnackBarContext/SnackBarContext";
import { SnackBarVariant } from "../SnackbarWrapper/SnackbarWrapper";
import ImageGallery from "../ImageGallery/ImageGallery";
import HttpHeader from '../../header';
import { getFieldTitle, buildFieldRequiredMap, buildFieldVisibilityMap, DATE_TYPE, defaultWebsiteIndividualFields, formatGraphQLErrorMessage, getUploadedImageByKey, returnfileContentTypeAndExtention } from '../utils';
import { ApolloError, useLazyQuery, useMutation } from '@apollo/client';
import { UPDATE_CUSTOMER, DELETE_CUSTOMER_DOCUMENT_AND_NOTIFY } from '../../graphql/user/updateUser';
import FlatPickerBar from '../FlatPicker';
import ImageUpload from './ImageUpload';
import { IdentityVerificationCard } from "../IdentityVerification/IdentityVerificationCard";
import * as UUID from "uuid";
import { useSelector } from "react-redux";
import { IAppState } from "../../store";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { GET_ALL_DOCUMENT_TYPES } from "../../graphql/customers/getAllDocumentTypesQuery";
import GetAppIcon from "@material-ui/icons/GetApp";
import { getLocalizedDateFormat, getLocalizedInsuranceNumberSyntex, getLocalisedLicense, getDefaultCountryCode } from "../../utils/localized.syntex";
import DeleteIcon from "@material-ui/icons/Delete";
import { useTranslation } from "react-i18next";
import { GET_CUSTOM_FORM_BY_TYPE } from "../../graphql/customers/getConsumerCustomForm";
import * as Yup from "yup";
import { TranslationKeys } from "../../utils/translations/types";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { Gender } from "../../reducers/drivers/const";

const httpHeader = HttpHeader.getInstance();

const StyledInput = withStyles(() =>
  createStyles({
    root: {
      border: "1px solid #c0c0c0",
      borderRadius: 6,
      padding: "8px 10px",
      marginTop: 5,
      transition: "border-color 0.2s",
    },
    focused: {
      borderColor: "var(--primary-color)",
    },
  })
)(InputBase);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputError: {
      color: "#D13135",
      padding: "5px 15px",
      fontSize: 12
    },
    selectRoot: {
      marginTop: 5
    }
  })
);

interface ILicenseDocument {
  documentKey?: string;
  document?: string;
}
interface IProps {
  customer: ICustomer | IBusinessCustomerApprovedDriverInput;
  onAccount?: boolean
}

const licenseImageInitial: ILicenseDocument[] = [{
  documentKey: "",
  document: ""
}, {
  documentKey: "",
  document: ""
}]

export interface IDocumentType {
  id?: string;
  typeName: string;
  hasExpiry: boolean;
  description?: string;
  reminderBefore?: number
  createdAt?: string;
  expiryDate?: any;
}

export interface IUploadDocumentValues {
  id: string;
  title: string;
  expiryDate: string;
  documentType: string;
  reminderBefore: number;
  createdAt: string;
  documentKey: string;
  documentName: string;
}

const defaultValues: IUploadDocumentValues = {
  id: "",
  title: "",
  createdAt: new Date().toISOString(),
  documentKey: "",
  documentType: "",
  reminderBefore: 0,
  expiryDate: "",
  documentName: ""
};

export const getCountryFromLocaleString = (localeString: string) => {
  const alpha2 = localeString.slice(-2);
  if (alpha2) {
    return alpha2;
  }
  return "GB"
}

const ProfileScreen: React.FC<IProps> = ({ customer, onAccount }) => {
  const snackbar = useSnackBar();
  const classes = useStyles();
  const history = useHistory();
  const { _e_ } = useSelector((state: IAppState) => state.authReducer);
  const website = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite);
  const { country } = website.organisation.address;
  const [licenseImages, setLicenseImages] = useState<ILicenseDocument[]>(licenseImageInitial);
  const [open, setOpen] = useState<boolean>(false);
  const [editing, setEditing] = useState(false);
  const _newImageKeys = useMemo(() => ["", ""], []);
  const [profileImgUrl, setProfileImgUrl] = useState<string>("");
  const [profileImg, setProfileImg] = useState("");
  const [loading, setLoading] = useState(false);
  const [allDocumentTypes, setAllDocumentTypes] = useState<IDocumentType[]>([]);
  const [customers, setCustomer] = useState(customer);
  const [uploadInProgress, setUploadInProgress] = useState<boolean>(false);
  const [declinedNote, setDeclinedNote] = useState<string>("");
  const [selectedDocument, setSelectedDocument] = useState<IDocumentType>();
  const [inputValues, setInputValues] = useState<IUploadDocumentValues>(
    defaultValues
  );
  const [documents, setDocuments] = useState<ICustomerDocument[]>(customers.documents || []);
  const [uploadInProgressIndex, setUploadInProgressIndex] = useState(null);
  const [expiryDates, setExpiryDates] = useState<{ [key: string]: string }>({});
  const [singleUploadInProgress, setSingleUploadInProgress] = useState(false);
  const [allRequiredDocument, setAllRequiredDocument] = useState<IDocumentType[]>([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [documentToDelete, setDocumentToDelete] = useState<string | null>(null)
  const [newlyAddedDocuments, setNewlyAddedDocuments] = useState<string[]>([])
  const [documentsMarkedForDeletion, setDocumentsMarkedForDeletion] = useState<string[]>([])
  const [requiredMap, setRequiredMap] = useState<Record<string, boolean>>(
    buildFieldRequiredMap(defaultWebsiteIndividualFields)
  );
  const [getAllDocumentTypes, { data: allDocumentTypesData, loading: documentTypesLoading }] = useLazyQuery(GET_ALL_DOCUMENT_TYPES);
  const user = useSelector((state: IAppState) => state.authReducer.user);
  const {
    id: organisationId,
  } = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite.organisation);
  const userType = user?.businesscustomers ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL;
  const isDriver = user?.businesscustomers?.approvedDrivers.some(driver => driver?.id === customer?.id)
  const isVerificationPending = customer.status && [CustomerVerificationStatus.PENDING, CustomerVerificationStatus.DECLINED].includes(customer.status as CustomerVerificationStatus);
  const authState = useSelector((state: IAppState) => state.authReducer);
  const isNotDriver = (authState.accountType === AccountType.INDIVIDUAL || (authState.accountType === AccountType.BUSINESS && ((website.organisation.enableBookingCreationForApprovedDriver && user?.role == UserRole.DRIVER) || user?.role !== UserRole.DRIVER)))
  const lgDown = useMediaQuery('(max-width: 1200px)')
  const mdDown = useMediaQuery('(max-width: 960px)')
  const { t } = useTranslation()
  const [phoneError, setPhoneError] = useState<string>("");
  const [countryCode, setCountry] = useState<any>(
    getDefaultCountryCode(country)
  );


  const [updateCustomer] = useMutation(UPDATE_CUSTOMER, {
    onCompleted: (data) => {
      setEditing(false);
      window.location.reload();
      snackbar({
        message: t("snackBar:customerInfoSaved"),
        variant: SnackBarVariant.SUCCESS
      });
    },
    onError: (error: ApolloError) =>
      snackbar({
        message: formatGraphQLErrorMessage(error.message),
        variant: SnackBarVariant.ERROR
      })
  });

  const handleDeleteDocument = (documentId: string) => {
    setDocumentToDelete(documentId)
    setDeleteModalOpen(true)
  }
  const [consumerDeleteCustomerDocument, { loading: deleteLoading }] = useMutation(
    DELETE_CUSTOMER_DOCUMENT_AND_NOTIFY,
    {
      onCompleted: (data) => {
        const result = data?.consumerDeleteCustomerDocument;
        if (result?.success) {
          setDocuments((docs) => docs.filter((doc) => doc.id !== documentToDelete));
          setDeleteModalOpen(false);
          setDocumentToDelete(null);
          snackbar({
            message: t("snackBar:documentDeleted"),
            variant: SnackBarVariant.SUCCESS,
          });
        } else {
          snackbar({
            message: result?.message || t("snackBar:documentDeleteFailed"),
            variant: SnackBarVariant.ERROR,
          });
        }
      },
      onError: (error) => {
        snackbar({
          message: t("snackBar:documentDeleteError"),
          variant: SnackBarVariant.ERROR,
        });
      },
      fetchPolicy: "no-cache",
    }
  );

  const [getCustomFormByType] = useLazyQuery(GET_CUSTOM_FORM_BY_TYPE, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {

      if (data?.getConsumerCustomFormType?.config?.website?.fields.length) {
        const customMap = buildFieldRequiredMap(data.getConsumerCustomFormType.config.website.fields);
        setRequiredMap(customMap);
      } else {
        const defaultMap = buildFieldRequiredMap(defaultWebsiteIndividualFields);
        setRequiredMap(defaultMap);
      }
    },
    onError: (error: ApolloError) => {
      snackbar({
        message: formatGraphQLErrorMessage(error.message),
        variant: SnackBarVariant.ERROR
      });
      const defaultMap = buildFieldRequiredMap(defaultWebsiteIndividualFields);
      setRequiredMap(defaultMap);
    }
  });

  useEffect(() => {
    getCustomFormByType({
      variables: {
        organisationId: organisationId,
        formType: "INDIVIDUAL",
        atBranchLevel: false
      }
    })
  }, [])

  const createCustomerValidationSchema = (
    requiredMap: Record<string, boolean>,
    t: (key: string, options?: Record<string, any>) => string
  ) => {
    const createConditionalString = (
      key: string,
      errorKey: TranslationKeys,
      interpolationValues?: Record<string, string | number>
    ) => {
      const base = Yup.string()
        .nullable()
        .transform((value) => (value === "" ? null : value));

      return requiredMap[key]
        ? interpolationValues
          ? base.required(t(errorKey, { ...interpolationValues }))
          : base.required(t(errorKey))
        : base;
    };

    const createConditionalEmail = (fieldKey: string, labelKey: string) => {
      const base = Yup.string().email(
        t("validation:pleaseEnterAValidEmail", { field: t(labelKey) })
      );
      return requiredMap[fieldKey]
        ? base.required(
          t("validation:emailIsRequired", { field: t(labelKey) })
        )
        : base;
    };

    const createConditionalPhone = (fieldKey: string, labelKey: string) => {
      const base = Yup.string().test(
        "is-valid-phone",
        t("root:invalidPhoneNumber"),
        (value) => {
          if (!value) return true;
          return isValidPhoneNumber(value);
        }
      );

      return requiredMap[fieldKey]
        ? base.required(
          t("validation:phoneNumberRequired", {
            field: t(labelKey),
          })
        )
        : base;
    };

    const createConditionalPassport = (key: string) => {
      const base = Yup.string()
        .max(9, t("validation:passportNineCharacters"))
        .nullable();

      return requiredMap[key]
        ? base.required(t("validation:passportIsRequired"))
        : base;
    };

    const createConditionalAccountNumber = (key: string) => {
      const base = Yup.string().nullable();

      return requiredMap[key]
        ? base.required(t("validation:accountNumberRequired"))
        : base;
    };

    return Yup.object().shape({
      nationalInsuranceNumber: createConditionalString(
        "nationalInsuranceNumber",
        "validation:nationalInsuranceNumberRequired"
      ),

      profession: createConditionalString(
        "profession",
        "validation:professionIsRequired"
      ),

      dateOfBirth: createConditionalString(
        "dateOfBirth",
        "root:dateOfBirth"
      ).nullable(),

      email: createConditionalEmail("email", "root:emailAddress"),

      secondaryEmail: createConditionalEmail(
        "secondaryEmail",
        "root:secondaryEmailAddress"
      ),

      phoneNumber: Yup.object().shape({
        phone: createConditionalPhone("phoneNumber", "root:phoneNumber"),
        country: Yup.string(),
      }),

      secondaryPhoneNumber: Yup.object().shape({
        phone: createConditionalPhone(
          "secondaryPhoneNumber",
          "root:secondaryPhoneNumber"
        ),
        country: Yup.string(),
      }),

      gender: createConditionalString(
        "gender",
        "validation:genderRequired"
      ),

      customerPCONumber: createConditionalString(
        "customerPCONumber",
        "validation:customerPCONumberRequired"
      ),

      accountNumber: createConditionalString("accountNumber", "validation:accountNumberRequired"),

      license: Yup.object().shape({
        licenseNumber: createConditionalString(
          "licenseNumber",
          "validation:licenceNumberRequired",
          { licenceSyntax: getLocalisedLicense(country) }
        ),
        authority: createConditionalString(
          "authority",
          "validation:authorityRequired"
        ).nullable(),
        dateOfIssue: createConditionalString(
          "dateOfIssue",
          "root:drivingLicenceIssueDate"
        ).nullable(),
        dateOfExpiry: createConditionalString(
          "dateOfExpiry",
          "validation:licenceExpiryDateRequired",
          { licenceSyntax: getLocalisedLicense(country) }
        ).nullable(),
      }),

      passportNumber: createConditionalPassport("passportNumber"),
    });
  };

  const validationSchema = createCustomerValidationSchema(requiredMap, t)
  const confirmDeleteDocument = () => {
    if (documentToDelete) {
      setDocumentsMarkedForDeletion((prev) => [...prev, documentToDelete])
      setDocuments((docs) => docs.filter((doc) => doc.id !== documentToDelete))
      setDeleteModalOpen(false)
      setDocumentToDelete(null)
      snackbar({
        message: t("snackBar:documentMarkedForDeletion"),
        variant: SnackBarVariant.SUCCESS,
      })
    }
  }

  useEffect(() => {
    const promises: any[] = [];
    try {
      if (
        customer &&
        customer.license &&
        customer.license.images &&
        customer.license.images.length
      ) {
        const dlImages: ILicenseDocument[] = [...licenseImageInitial];
        customer.license.images.map((img: string, index: number) => {
          _newImageKeys[index] = img
          promises.push(
            (async () => {
              try {
                const data: any = await getImage(img);
                dlImages[index] = {
                  documentKey: img,
                  document: data,
                };
              } catch (error) {
                return;
              }
            })()
          );
        });
        Promise.all(promises).then(() => {
          setLicenseImages(dlImages);
        });
      } else {
        const newLicense = {
          ...customer.license,
          images: [],
        };
        customer = {
          ...customer,
          license: newLicense,
        }
      }
    } catch (error) {
      throw error;
    }
  }, [customer]);

  useEffect(() => {
    getAllDocumentTypes();
    if (customer && customer.showDeclinedNote) {
      const sortedNotes = [...customer.notes].sort((a, b) => d.fromISO(b.createdDate).toMillis() - d.fromISO(a.createdDate).toMillis());
      const latestDeclinedNote = sortedNotes.find((note) => note.description.includes("Customer verification declined -"));
      if (latestDeclinedNote) {
        const fullNote = latestDeclinedNote.description;
        const reason = fullNote.replace("Customer verification declined -", "").trim();
        setDeclinedNote(reason);
      }
    }
    (async () => {
      if (customer && customer.profilePicture) {
        const image = await getUploadedImageByKey(customer.profilePicture);
        setProfileImg(image);
      }
    })();
  }, [customer]);

  useEffect(() => {
    if (allDocumentTypesData && allDocumentTypesData.getAllDocumentTypes) {
      const enabledDocTypes = allDocumentTypesData.getAllDocumentTypes.filter((obj: any) => !obj.isMandatory);
      setAllDocumentTypes(enabledDocTypes);
    }
  }, [allDocumentTypesData]);

  useEffect(() => {
    if (allDocumentTypesData && allDocumentTypesData.getAllDocumentTypes) {
      const requiredDocuments = allDocumentTypesData.getAllDocumentTypes.filter(
        (e: any) => {
          return (
            e.isMandatory &&
            e.applicableFor &&
            e.applicableFor.length &&
            e.applicableFor.includes(userType)
          )
        }
      )
      setAllRequiredDocument(requiredDocuments);
    }
  }, [allDocumentTypesData, userType])

  const getImage = async (url: string) => {
    if (url) {
      try {
        const file = await getSignedUrl(url);
        return file;
      } catch (error: any) {
        if (error && error.message) {
          snackbar({
            message: error.message,
            variant: SnackBarVariant.ERROR,
          });
        }
      }
    }
  };

  const uploadProfileImg = async (
    e: any,
  ) => {
    try {
      var filesArr = Array.prototype.slice.call(e.target.files);
      const file = filesArr[0];
      if (file.size > 52428800) {
        throw new Error("File size exceeded limit of 50MB");
      }
      if (file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpg") {
        const { fileExtension, contentType } = returnfileContentTypeAndExtention(file);
        const uniqueId = UUID.v4();
        const key = `${uniqueId}.${fileExtension}`;
        if (_e_) {
          setLoading(true);
          await _e_
            .add({
              name: key,
              file: file,
              complete: async () => {
                setProfileImgUrl(key);
                snackbar({
                  message: t("snackBar:profileImageUploaded"),
                  variant: SnackBarVariant.SUCCESS
                });
                const uploadedFile = await getUploadedImageByKey(key);
                if (uploadedFile) {
                  setProfileImg(uploadedFile);
                }
                setProfileImg(uploadedFile);
                setLoading(false);
              }
            });
        }
      } else {
        return snackbar({
          message: t("snackBar:uploadImageFormatError"),
          variant: SnackBarVariant.ERROR
        });
      }
    } catch (err: any) {
      snackbar({
        message: err.message,
        variant: SnackBarVariant.ERROR
      });
    }
  };

  const isImageFileType = (fileType: string) => {
    return fileType === "image/png" || fileType === "image/jpg" || fileType === "image/jpeg";
  }

  const checkUploadFileFormat = (fileType: string) => {
    if (
      fileType === "application/pdf" ||
      fileType === "image/png" ||
      fileType === "image/jpg" ||
      fileType === "image/jpeg"
    ) {
      return true;
    }
  };


  // Upload the document to s3
  async function uploadDocument(
    e: any,
    index?: any,
    isSingleUpload: boolean = false
  ) {
    try {
      if (isSingleUpload) {
        if (!selectedDocument) {
          return snackbar({
            message: t("snackBar:selectDocumentType"),
            variant: SnackBarVariant.ERROR
          });
        }
        if (selectedDocument && selectedDocument.hasExpiry && !inputValues.expiryDate) {
          return snackbar({
            message: t("snackBar:selectExpiryDate"),
            variant: SnackBarVariant.ERROR
          });
        }
      }

      const file = e.target.files[0]
      if (!file) return
      // 50MB limit exceeded
      if (file.type === "application/pdf" && file.size > 52428800) {
        throw new Error(t("snackBar:fileSizeExceeded50mb"));
      }
      if (isImageFileType(file.type) && file.size > 5242880) {
        throw new Error(t("snackBar:fileSizeExceeded5mb"));
      }
      const fileName = file.name.split(".")[0];
      if (isSingleUpload) {
        setSingleUploadInProgress(true);
      } else {
        setUploadInProgressIndex(index);
        setUploadInProgress(true);
      }

      if (checkUploadFileFormat(file.type)) {
        const { fileExtension, contentType } = returnfileContentTypeAndExtention(file);
        const uniqueId = UUID.v4();
        const key = `${website.tenantId}/${uniqueId}.${fileExtension}`;
        if (_e_) {
          await _e_
            .add({
              name: key,
              file: file,
              complete: async () => {
                const updatedDocument = {
                  id: uniqueId,
                  documentName: fileName,
                  documentKey: key,
                  documentType: isSingleUpload
                    ? selectedDocument?.typeName || ""
                    : inputValues.documentType,
                  title: inputValues.title || "",
                  expiryDate: inputValues.expiryDate || "",
                  reminderBefore: inputValues.reminderBefore || 0,
                  createdAt: inputValues.createdAt || new Date().toISOString(),
                }
                const newDocuments = [...documents, updatedDocument]
                setDocuments(newDocuments)
                setNewlyAddedDocuments((prev) => [...prev, uniqueId])
                snackbar({
                  message: t("snackBar:uploadSuccess"),
                  variant: SnackBarVariant.SUCCESS,
                });
                if (isSingleUpload) {
                  setSingleUploadInProgress(false);
                } else {
                  setUploadInProgress(false);
                }
              },
            });
        }
      } else {
        if (isSingleUpload) {
          setSingleUploadInProgress(false);
        } else {
          setUploadInProgress(false);
        }
        snackbar({
          message: t("snackBar:invalidUploadFormat"),
          variant: SnackBarVariant.ERROR,
        })
      }
    } catch (err: any) {
      snackbar({
        message: formatGraphQLErrorMessage(err.message),
        variant: SnackBarVariant.ERROR
      });
    }
  }

  const checkDeleteOrDownloadFileType = (documentUrl: string) => {
    const fileExtension = documentUrl.split(".")[1];
    let contentType: string = "";
    if (fileExtension === "doc") {
      contentType = "application/msword";
    } else if (fileExtension === "docx") {
      contentType =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    } else if (fileExtension === "pdf") {
      contentType = "application/pdf";
    } else if (fileExtension === "application/zip") {
      contentType = "application/zip";
    } else if (fileExtension === "application/x-zip-compressed") {
      contentType = "application/x-zip-compressed";
    } else if (fileExtension === "png") {
      contentType = "image/png";
    } else if (fileExtension === "jpg") {
      contentType = "image/jpg";
    } else if (fileExtension === "jpeg") {
      contentType = "image/jpeg";
    }
    return { fileExtension, contentType };
  };

  async function downloadDocument(documentKey: string, title: string) {
    const { fileExtension } = checkDeleteOrDownloadFileType(documentKey);
    const file = await getSignedUrl(documentKey);
    const url: any = file;
    fetch(url, {
      method: "GET",
    })
      .then((response) => response.blob())
      .then((blob) => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileExtension ? `${title}.${fileExtension}` : title;
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  }
  const sortedDocuments = [...allRequiredDocument].sort((a, b) => {
    const uploadedDocA = customers?.documents?.find((d) => d.documentType === a.typeName)
    const uploadedDocB = customers?.documents?.find((d) => d.documentType === b.typeName);
    const dateA = uploadedDocA && uploadedDocA.createdAt ? new Date(uploadedDocA.createdAt) : new Date(0);
    const dateB = uploadedDocB && uploadedDocB.createdAt ? new Date(uploadedDocB.createdAt) : new Date(0);
    return dateB.getTime() - dateA.getTime();
  });
  const convertNotesToHTML = (note: string | undefined) => {
    if (typeof note !== 'string') {
      return note;
    }
    if (!note.includes('\n')) {
      return note;
    }
    const newNote = note.split('\n').reduce<JSX.Element[]>(
      (acc, line, index) => {
        acc.push(<React.Fragment key={index}>{line}</React.Fragment>);
        acc.push(<br key={`br-${index}`} />);
        return acc;
      }, []
    );
    return newNote
  };
  const HTMLdeclinedNote = convertNotesToHTML(declinedNote);

  const nationalInsuranceNumberPlaceholder = getFieldTitle(
    getLocalizedInsuranceNumberSyntex(country),
    requiredMap.nationalInsuranceNumber
  );

  const passportPlaceholder = getFieldTitle(
    t("root:passportNumber"),
    requiredMap.passportNumber
  );

  const professionPlaceholder = getFieldTitle(
    `${t('root:profession')}`,
    requiredMap.profession
  );

  const licenseNumberPlaceholder = getFieldTitle(
    t('root:drivingLicenseNumber', { licenceSyntax: getLocalisedLicense(country) }),
    requiredMap.licenseNumber
  );

  const licenseDateOfExpiryPlaceholder = getFieldTitle(
    t('root:licenceExpiryDate', { licenceSyntax: getLocalisedLicense(country) }),
    requiredMap.dateOfExpiry
  );

  const licenseIssuedByPlaceholder = getFieldTitle(
    t('root:licenceIssuedBy', { licenceSyntax: getLocalisedLicense(country) }),
    requiredMap.authority
  );

  const dateOfBirthPlaceholder = getFieldTitle(
    t('root:dateOfBirth'),
    requiredMap.dateOfBirth
  );

  const licenseDateOfIssuePlaceholder = getFieldTitle(
    t('root:drivingLicenceIssueDate'),
    requiredMap.dateOfIssue
  );

  const secondaryEmailAddressPlaceholder = requiredMap.secondaryEmailAddress
    ? `${t("root:secondaryEmailAddress")} *`
    : t("root:secondaryEmailAddress");

  const secondaryPhoneNumberPlaceholder = requiredMap.secondaryPhoneNumber
    ? `${t("root:secondaryPhoneNumber")} *`
    : t("root:secondaryPhoneNumber");

  const customerPCONumberPlaceholder = requiredMap.customerPCONumber
    ? `${t("root:pcoPrivateHiresHireDLNo")} *`
    : t("root:pcoPrivateHiresHireDLNo");

  const accountNumberPlaceholder = requiredMap.accountNumber
    ? `${t("root:accountNumber")} *`
    : t("root:accountNumber");

  const genderPlaceholder = requiredMap.gender
    ? `${t("root:gender")} *`
    : t("root:gender");

  return (
    <div className={styles.column}>
      {onAccount && <IdentityVerificationCard customer={customer as ICustomer} />}
      {!onAccount && <div className="flex cross-center margin-bottom padding-bottom">
        <div className="flex cross-center">
          <IconButton
            size="small"
            edge="start"
            onClick={() => history.goBack()}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography className="semi-bold">{t('root:driverDetails')}</Typography>
        </div>
        <span
          className="flex fill margin-left"
          style={{ borderBottom: "1px solid #e9e9e9", marginTop: 4 }}
        ></span>
      </div>}
      <Formik
        initialValues={customer}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          // identityVerification is output-only (from GET_USER's customer.identityVerification),
          // not a field on CustomerUpdateInput - the backend manages Credas verification state
          // itself. Left in rest, it fails the mutation with "Field identityVerification is not
          // defined by type CustomerUpdateInput".
          const { id, tenantId, notes, showDeclinedNote, approvedDrivers, creditSafeData, identityVerification, ...rest } = values;
          rest.documents = documents
          const processDeletedDocuments = async () => {
            const deletePromises = documentsMarkedForDeletion.map((docId) =>
              consumerDeleteCustomerDocument({
                variables: {
                  customerId: values.id,
                  documentId: docId,
                },
              }),
            )
            try {
              await Promise.all(deletePromises)
              setDocumentsMarkedForDeletion([])
            } catch (error) {
              console.error("Error deleting documents:", error)
            }
          }
          processDeletedDocuments().then(() => {
            updateCustomer({
              variables: {
                customer: {
                  ...rest,
                  profilePicture: profileImgUrl ? profileImgUrl : rest.profilePicture,
                  license: {
                    ...rest.license,
                    images: _newImageKeys,
                  },
                },
                customerId: values.id,
              },
            })
          })
        }}
      >
        {(formikProps) => (
          <Form className={styles.profile}>
            <div className={lgDown ? "flex col-flex margin-top padding-bottom" : "flex cross-center margin-top padding-bottom"}>
              <div className="flex fill cross-center margin-bottom">
                <div className={styles.avatar}>
                  {customer.profilePicture && !editing ? (
                    <span>
                      <img src={profileImg} alt={t("root:profileImage")} height={"70"} width={"70"} />
                    </span>
                  ) : (
                    <>
                      {editing ? (
                        <>
                          <span>
                            <label htmlFor={"profileImg"} style={{ cursor: "pointer" }}>
                              {profileImg ? (
                                <img src={profileImg} alt={t("root:profileImage")} height={"70"} width={"70"} />
                              ) : (
                                <span>
                                  <CloudUploadIcon />
                                </span>
                              )}
                            </label>
                          </span>
                          <input accept="image/*" style={{ display: 'none' }} onChange={(e: any) => { uploadProfileImg(e); e.target.value = null }} id={"profileImg"} type="file" />
                        </>
                      ) : (
                        <span className="font-large bold">
                          {customer.firstName.slice(0, 1).toUpperCase()}
                          {customer.lastName.slice(0, 1).toUpperCase()}
                        </span>
                      )}
                    </>
                  )}

                </div>
                <div className="flex fill col-flex margin-left margin-right">
                  <Typography
                    variant="h3"
                    className="semi-bold capitalize"
                    style={{ marginLeft: 1, marginBottom: 4 }}
                  >
                    {customer.firstName} {customer.middleName} {customer.lastName}
                  </Typography>
                  <span className={lgDown ? "flex col-flex font-medium opacity50 " : "flex cross-center font-medium opacity50"}>
                    <div className="flex cross-center">
                      <EmailIcon style={{ fontSize: 17, marginRight: 3 }} />
                      <span>{customer.email}</span>
                    </div>
                    <div className="flex cross-center" style={{ marginTop: lgDown ? 5 : 0 }}>
                      <PhoneIcon
                        style={{ fontSize: 17, marginRight: 3, marginLeft: lgDown ? 0 : 10 }}
                      />
                      <span>{customer.phoneNumber.phone}</span>
                    </div>
                  </span>
                </div>
              </div>
              {onAccount && <div className="flex cross-center" style={{ marginLeft: lgDown ? 5 : 0 }}>
                {!editing && <Button
                  onClick={() => {
                    setEditing(true);
                  }}
                  variant="outlined"
                  color="default" size="large"
                  disableRipple
                  style={{ textTransform: "initial", fontSize: 14, fontWeight: 500, padding: "6px 14px" }}
                >
                  {t('misc:edit')}
                </Button>}
                <span className='margin-left'></span>
                <Button
                  onClick={() => {
                    const lang = localStorage.getItem('lang');
                    httpHeader.resetHeaders();
                    localStorage.clear();
                    if (lang) {
                      localStorage.setItem('lang', lang);
                    }
                    window.location.replace("/");
                  }}
                  variant="outlined"
                  color="default" size="large"
                  disableRipple
                  style={{ textTransform: "initial", fontSize: 14, fontWeight: 500, padding: "6px 14px", whiteSpace: "nowrap" }}
                >
                  {t('misc:logOut')}
                </Button>
              </div>}
            </div>
            <div className={styles.card} style={{ marginRight: lgDown ? 0 : -250 }}>
              <Grid container spacing={2}>
                {website.organisation.requiresCustomerVerification && !isDriver && (
                  <>
                    <Grid item xs={12} sm={12} md={12}>
                      <Typography variant="body1">
                        {t('root:customerVerificationStatus')} :
                        <span style={{
                          fontWeight: "bold", color: customer.status === CustomerVerificationStatus.PENDING ||
                            customer.status === CustomerVerificationStatus.IN_REVIEW ? "organge" :
                            customer.status === CustomerVerificationStatus.DECLINED ? "red" : "green"
                        }}> {customer.status} </span>
                      </Typography>
                    </Grid>
                    {declinedNote && customer.status === CustomerVerificationStatus.DECLINED && (
                      <Grid item xs={12} sm={12} md={12}>
                        <Typography variant="body1">
                          {t('root:note')}:
                          <span style={{ fontWeight: "bold" }}> {HTMLdeclinedNote} </span>
                        </Typography>
                      </Grid>
                    )}
                  </>
                )}

                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">
                    {secondaryEmailAddressPlaceholder}
                  </Typography>

                  {!editing ? (
                    <Typography variant="body1" className="semi-bold">
                      {customer.secondaryEmail || t("root:na")}
                    </Typography>
                  ) : (
                    <Field name="secondaryEmail">
                      {({ field, meta: { touched, error } }: FieldProps) => (
                        <>
                          <StyledInput
                            {...field}
                            placeholder={secondaryEmailAddressPlaceholder}
                            fullWidth
                            error={touched && Boolean(error)}
                          />
                          <Typography variant="body2" color="error">
                            {touched && Boolean(error) && error}
                          </Typography>
                        </>
                      )}
                    </Field>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">
                    {genderPlaceholder}
                  </Typography>

                  {!editing ? (
                    <Typography variant="body1" className="semi-bold">
                      {customer.gender || t("root:na")}
                    </Typography>
                  ) : (
                    <Field name="gender">
                      {({ field, meta: { touched, error } }: FieldProps) => (
                        <>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            error={touched && Boolean(error)}
                          >
                            <Select
                              {...field}
                              value={field.value || ""}
                              displayEmpty
                              className={classes.selectRoot}
                            >
                              {Object.values(Gender).map((element: string, key: number) => (
                                <MenuItem value={element} key={key}>
                                  {element.replace(/_/g, " ")}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <Typography variant="body2" color="error">
                            {touched && Boolean(error) && error}
                          </Typography>
                        </>
                      )}
                    </Field>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">
                    {secondaryPhoneNumberPlaceholder}
                  </Typography>

                  {!editing ? (
                    <Typography variant="body1" className="semi-bold">
                      {customer.secondaryPhoneNumber?.phone || t("root:na")}
                    </Typography>
                  ) : (
                    <Field name="secondaryPhoneNumber.phone">
                      {({ field, meta: { touched, error } }: FieldProps) => (
                        <div className="phone-input-container" style={{ marginTop: 5 }}>
                          <div
                            style={{
                              border: `1px solid ${touched && Boolean(error) ? "#D13135" : "#c0c0c0"
                                }`,
                              borderRadius: 6,
                            }}
                          >
                            <PhoneInput
                              {...field}
                              international={false}
                              defaultCountry={getCountryFromLocaleString(
                                website.organisation.locale
                              )}
                              onChange={(val: any) =>
                                formikProps.setFieldValue(
                                  "secondaryPhoneNumber.phone",
                                  val || ""
                                )
                              }
                              onCountryChange={(cc: any) => {
                                if (cc) {
                                  formikProps.setFieldValue(`secondaryPhoneNumber.country`, cc);
                                }
                              }}
                            />
                          </div>

                          <Typography variant="body2" color="error">
                            {touched && Boolean(error) && error}
                          </Typography>
                        </div>
                      )}
                    </Field>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography
                    variant="body1"
                    className="opacity60 padding-bottom--small"
                  >
                    {customerPCONumberPlaceholder}
                  </Typography>

                  {!editing ? (
                    <Typography variant="body1" className="semi-bold">
                      {customer.customerPCONumber || t("root:na")}
                    </Typography>
                  ) : (
                    <Field name="customerPCONumber">
                      {({ field, meta: { touched, error } }: FieldProps) => (
                        <>
                          <StyledInput
                            {...field}
                            placeholder={t("root:privateHiresNo")}
                            fullWidth
                            inputProps={{ maxLength: 10 }}
                            error={touched && Boolean(error)}
                          />
                          <Typography variant="body2" color="error">
                            {touched && Boolean(error) && error}
                          </Typography>
                        </>
                      )}
                    </Field>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">
                    {accountNumberPlaceholder}
                  </Typography>
                  {!editing
                    ?
                    <Typography variant="body1" className="semi-bold"> {customer.accountNumber || t("root:na")} </Typography>
                    :
                    <Field name="accountNumber">
                      {({ field, meta: { touched, error }, }: FieldProps) => (
                        <>
                          <StyledInput
                            {...field}
                            placeholder={accountNumberPlaceholder}
                            fullWidth
                            error={touched && Boolean(error)}
                          />
                          <Typography variant="body1" className={classes.inputError}>{touched && Boolean(error) && error}</Typography>
                        </>
                      )}
                    </Field>}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">{nationalInsuranceNumberPlaceholder}</Typography>
                  {!editing ? <Typography variant="body1" className="semi-bold">{customer.nationalInsuranceNumber || t("root:na")}</Typography> :
                    <Field name="nationalInsuranceNumber">
                      {({ field, meta: { touched, error }, }: FieldProps) => (
                        <>
                          <StyledInput
                            {...field}
                            placeholder={t('root:enterNationalInsuranceNumber')}
                            fullWidth
                            error={touched && Boolean(error)}
                          />
                          <Typography variant="body1" className={classes.inputError}>{touched && Boolean(error) && error}</Typography>
                        </>
                      )}
                    </Field>}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">{professionPlaceholder}</Typography>
                  {!editing ? <Typography variant="body1" className="semi-bold"> {customer.profession || t("root:na")} </Typography> :
                    <Field name="profession">
                      {({ field, meta: { touched, error }, }: FieldProps) => (
                        <>
                          <StyledInput
                            {...field}
                            placeholder={t('root:enterYourProfession')}
                            fullWidth
                            error={touched && Boolean(error)}
                          />
                          <Typography variant="body1" className={classes.inputError}>{touched && Boolean(error) && error}</Typography>
                        </>
                      )}
                    </Field>}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">{dateOfBirthPlaceholder}</Typography>
                  {!editing ? <Typography variant="body1" className="semi-bold"> {(customer as any).dateOfBirth ? getLocalizedDateFormat(country, (customer as any).dateOfBirth, DATE_TYPE.CONDENSED) : t("root:na")} </Typography> :
                    <FlatPickerBar
                      enableTime={false}
                      handleDateChange={(value: Date) => {
                        if (!isNaN(value.getTime())) {
                          formikProps.setFieldValue("dateOfBirth", d.fromJSDate(value).startOf("day").toUTC().toISO()!);
                        } else {
                          formikProps.setFieldValue("dateOfBirth", "");
                        }
                      }}
                      label={""}
                      identifier={"dateOfBirth"}
                      placeholderValue={t("root:dateOfBirth")}
                      value={formikProps.values.dateOfBirth ? getLocalizedDateFormat(country, formikProps.values.dateOfBirth, DATE_TYPE.CONDENSED) : ""}
                      maxDate={getLocalizedDateFormat(country, d.now().toUTC().toISO(), DATE_TYPE.CONDENSED)}
                      country={country}
                    />
                  }
                  {editing && (
                    <Typography variant="body1" className={classes.inputError}>
                      {formikProps.touched.dateOfBirth && Boolean(formikProps.errors.dateOfBirth) && formikProps.errors.dateOfBirth}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className="margin-bottom padding-bottom">
                    <Typography variant="body1" className="opacity60 padding-bottom--small" > {licenseDateOfIssuePlaceholder} </Typography>
                    {!editing ? <Typography variant="body1" className="semi-bold"> {customer.license?.dateOfIssue ? getLocalizedDateFormat(country, customer.license.dateOfIssue, DATE_TYPE.CONDENSED) : t("root:na")} </Typography> :
                      <FlatPickerBar
                        enableTime={false}
                        handleDateChange={(value: Date) => {
                          if (!isNaN(value.getTime())) {
                            formikProps.setFieldValue("license.dateOfIssue", d.fromJSDate(value).startOf("day").toUTC().toISO());
                          } else {
                            formikProps.setFieldValue("license.dateOfIssue", "");
                          }
                        }}
                        label={""}
                        identifier={"dateOfIssue"}
                        placeholderValue={t("root:drivingLicenceIssueDate")}
                        value={formikProps.values.license?.dateOfIssue ? getLocalizedDateFormat(country, formikProps.values.license.dateOfIssue, DATE_TYPE.CONDENSED) : ""}
                        maxDate={getLocalizedDateFormat(country, d.now().toUTC().toISO(), DATE_TYPE.CONDENSED)}
                        country={country}
                      />
                    }
                    {editing && (
                      <Typography variant="body1" className={classes.inputError}>
                        {formikProps.touched.license?.dateOfIssue && Boolean(formikProps.errors.license?.dateOfIssue) && formikProps.errors.license?.dateOfIssue}
                      </Typography>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className="margin-bottom">
                    <Typography variant="body1" className="opacity60 padding-bottom--small" > {licenseNumberPlaceholder} </Typography>
                    {!editing ? <Typography variant="body1" className="semi-bold"> {customer.license.licenseNumber || t("root:na")} </Typography> :
                      <Field name="license.licenseNumber">
                        {({ field, meta: { touched, error }, }: FieldProps) => (
                          <>
                            <StyledInput
                              {...field}
                              placeholder={`${t("root:enterDriving")} ${getLocalisedLicense(country)} ${t("root:number")} `}
                              fullWidth
                              error={touched && Boolean(error)}
                            />
                            <Typography variant="body1" className={classes.inputError}>{touched && Boolean(error) && error}</Typography>
                          </>
                        )}
                      </Field>}
                  </div>
                  {editing && (<Typography variant="body1" className="opacity60 padding-bottom--small padding-top" > {`${t("root:driving")} ${getLocalisedLicense(country)} ${t("root:image")}`} </Typography>)}
                  <div className="flex">
                    {licenseImages.map((image, index) => {
                      return (
                        <div key={index} className={styles.dlImage}>
                          {editing ?
                            <ImageUpload
                              label={index ? t("root:uploadBack") : t("root:uploadFront")}
                              onUpload={(key, image) => {
                                _newImageKeys[index] = key
                              }}
                              id={`LICENCE_IMG_${index}`}
                            />
                            : <button
                              type="button"
                              onClick={() => image.document && setOpen(true)}
                              style={{
                                border: "none",
                                boxShadow: "none",
                                margin: 0,
                                padding: 0,
                                height: 56,
                                width: "100%",
                                cursor: "pointer",
                              }}
                            >
                              {image.document && <img src={image.document} alt="" />}
                            </button>}
                        </div>
                      );
                    })
                    }
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className="margin-bottom padding-bottom">
                    <Typography variant="body1" className="opacity60 padding-bottom--small" > {licenseIssuedByPlaceholder} </Typography>
                    {!editing ? <Typography variant="body1" className="semi-bold"> {customer.license.authority || t("root:na")} </Typography> :
                      <Field name="license.authority">
                        {({ field, meta: { touched, error }, }: FieldProps) => (
                          <>
                            <StyledInput
                              {...field}
                              placeholder={t('root:licenceIssuedBy', { licenceSyntax: getLocalisedLicense(country) })}
                              fullWidth
                              error={touched && Boolean(error)}
                            />
                            <Typography variant="body1" className={classes.inputError}>{touched && Boolean(error) && error}</Typography>
                          </>
                        )}
                      </Field>}
                  </div>
                  <div>
                    <Typography variant="body1" className="opacity60 padding-bottom--small" >  {licenseDateOfExpiryPlaceholder} </Typography>
                    {!editing ? <Typography variant="body1" className="semi-bold"> {customer.license.dateOfExpiry ? getLocalizedDateFormat(country, customer.license.dateOfExpiry, DATE_TYPE.CONDENSED) : t("root:na")} </Typography> :
                      <>
                        <FlatPickerBar
                          enableTime={false}
                          handleDateChange={(value: Date) => {
                            if (!isNaN(value.getTime())) {
                              formikProps.setFieldValue("license.dateOfExpiry", d.fromJSDate(value).endOf("day").toUTC().toISO()!)
                            } else {
                              formikProps.setFieldValue("license.dateOfExpiry", '')
                            }
                          }}
                          label={""}
                          identifier={""}
                          placeholderValue={` ${t('root:driving')} ${getLocalisedLicense(country)} ${t('root:expiryDate')}`}
                          value={formikProps.values.license.dateOfExpiry ? getLocalizedDateFormat(country, formikProps.values.license.dateOfExpiry, DATE_TYPE.CONDENSED) : ""}
                          minDate={d.now().startOf("day").toUTC().toISO()}
                          country={country}
                        />
                        <Typography
                          variant="body1"
                          className={classes.inputError}
                        >
                          {
                            formikProps.touched.license?.dateOfExpiry
                            && Boolean(formikProps.errors.license?.dateOfExpiry)
                            && formikProps.errors.license?.dateOfExpiry
                          }
                        </Typography>
                      </>
                    }
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" className="opacity60 padding-bottom--small">{passportPlaceholder}</Typography>
                  {!editing ? <Typography variant="body1" className="semi-bold"> {customer.passportNumber || t("root:na")} </Typography> :
                    <Field name="passportNumber">
                      {({ field, meta: { touched, error }, }: FieldProps) => (
                        <>
                          <StyledInput
                            {...field}
                            placeholder={t("root:enterPassportNumber")}
                            fullWidth
                            error={touched && Boolean(error)}
                            inputProps={{ maxLength: 9 }}
                          />
                          <Typography variant="body1" className={classes.inputError}>{touched && Boolean(error) && error}</Typography>
                        </>
                      )}
                    </Field>}
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                  <Typography variant="body1" className="opacity60 padding-bottom--small padding-top" > {t("root:document")} </Typography>
                </Grid>
                {editing ? (
                  <>
                    <Grid item xs={12} sm={6} md={4}>
                      <TextField
                        id="document-type-select"
                        select
                        fullWidth
                        label={t('root:selectDocument')}
                        value={selectedDocument?.typeName || ""}
                        onChange={(event) => {
                          const thisDocType = allDocumentTypes.find(
                            (docType) => docType.typeName === event.target.value,
                          )
                          if (thisDocType) {
                            setSelectedDocument(thisDocType)
                            setInputValues({
                              ...inputValues,
                              documentType: event.target.value,
                              reminderBefore: thisDocType.reminderBefore || 7,
                              expiryDate: ""
                            });
                          } else {
                            setSelectedDocument(undefined)
                          }
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                        SelectProps={{
                          MenuProps: {
                            style: {
                              maxHeight: 250,
                              maxWidth: 250
                            },
                          },
                        }}
                      >
                        {allDocumentTypes.map((item: any, index) => (
                          <MenuItem key={index} value={item.typeName}>
                            {item.typeName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {selectedDocument?.hasExpiry && (
                      <Grid item xs={12} sm={6} md={4}>
                        <FlatPickerBar
                          enableTime={false}
                          handleDateChange={(value: Date) => {
                            if (value) {
                              const expiryDate = d.fromJSDate(value).endOf("day").toUTC().toISO();
                              setInputValues({
                                ...inputValues,
                                expiryDate
                              });
                            }
                          }}
                          label={""}
                          identifier={"expiryDate"}
                          placeholderValue={t("root:expiryDate")}
                          value={getLocalizedDateFormat(country, inputValues.expiryDate, DATE_TYPE.CONDENSED)}
                          minDate={d.now().startOf("day").toUTC().toISO()}
                          country={country}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6} md={4} style={{ marginTop: 10 }}>
                      <span>
                        <label htmlFor={"documentUpload"} style={{ cursor: "pointer" }}>
                          <span style={{
                            backgroundColor: "black",
                            color: "#e2e2e2",
                            fontSize: 16,
                            fontWeight: "bold",
                            padding: "10px 16px",
                            borderRadius: 4
                          }}>
                            {singleUploadInProgress ? <CircularProgress size={20} thickness={5} /> : t("root:addFile")}
                          </span>
                        </label>
                      </span>
                      <input accept="image/jpg, image/jpeg, image/png, application/pdf" style={{ display: 'none' }} onChange={(e: any) => { uploadDocument(e, undefined, true); e.target.value = null }} id={"documentUpload"} type="file" />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} style={{ marginLeft: 10, paddingLeft: 0 }}>
                      <Typography variant="body1" className="opacity60 padding-bottom--small padding-top">
                        {t('root:listOfDocumentsUploaded')}
                      </Typography>
                    </Grid>
                    <TableContainer style={{ width: "100%", overflowX: "auto" }}>
                      <Table style={{ minWidth: 420 }} aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>{t('root:documentType')}</TableCell>
                            <TableCell align="left">{t('root:documentName')}</TableCell>
                            <TableCell align="right">{t('root:expiryDate')}</TableCell>
                            <TableCell align="right">{t('root:actions')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {documents && documents.length > 0 ? (
                            documents.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell component="th" scope="row">
                                  {row.documentType}
                                </TableCell>
                                <TableCell align="left">{row.documentName}</TableCell>
                                <TableCell align="right">
                                  {row.expiryDate
                                    ? getLocalizedDateFormat(country, row.expiryDate, DATE_TYPE.CONDENSED)
                                    : t("root:na")}
                                </TableCell>
                                <TableCell align="right">
                                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Tooltip title="Download">
                                      <IconButton
                                        size="small"
                                        onClick={() => downloadDocument(row.documentKey, row.documentName)}
                                      >
                                        <GetAppIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    {!newlyAddedDocuments.includes(row.id) && (
                                      <Tooltip title="Delete">
                                        <IconButton size="small" onClick={() => {

                                          handleDeleteDocument(row.id)
                                        }}>
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={4}>
                                <div style={{ marginLeft: 18, marginBottom: 7 }}>
                                  <span style={{ fontSize: 12 }}>{t("root:noDocumentsFound")}</span>
                                </div>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>

                  </>
                ) : (
                  <TableContainer style={{ width: "100%", overflowX: 'auto' }}>
                    <Table style={{ minWidth: 420 }} aria-label="simple table" size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>{t('root:documentType')}</TableCell>
                          <TableCell align="left">{t('root:documentName')}</TableCell>
                          <TableCell align="right">{t('root:expiryDate')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {customer && customer.documents && customer.documents.length > 0 ? customer.documents.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell component="th" scope="row">
                              {row.documentType}
                            </TableCell>
                            <TableCell align="left">{row.documentName}</TableCell>
                            <TableCell align="right">{row.expiryDate ? getLocalizedDateFormat(country, row.expiryDate, DATE_TYPE.CONDENSED) : t("root:na")}</TableCell>
                          </TableRow>
                        )) : (
                          <div style={{ marginLeft: 18, marginBottom: 7 }}>
                            <span style={{ fontSize: 12 }}>{t("root:noDataFound")}</span>
                          </div>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                {isNotDriver && editing && (
                  <>
                    <Grid item xs={12} sm={12} md={12} style={{ marginLeft: 10, paddingLeft: 0 }}>
                      <Typography variant="body1" className="opacity60 padding-bottom--small padding-top">
                        {t('root:listOfRequiredDocumentsUploaded')}
                      </Typography>
                    </Grid>
                    <TableContainer style={{ width: "100%", overflowX: 'auto' }}>
                      <Table style={{ minWidth: 800 }} aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("root:documentUpdatedAt")}</TableCell>
                            <TableCell>{t('root:documentType')}</TableCell>
                            <TableCell align="left">{t('root:documentName')}</TableCell>
                            <TableCell align="left">{t('root:expiryDate')}</TableCell>
                            {isVerificationPending && <TableCell align="left">{t("root:editExpiryDate")}</TableCell>}
                            <TableCell align="left">{t("root:status")}</TableCell>
                            <TableCell align="left">{t('root:actions')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {sortedDocuments.map((doc, index) => {
                            const uploadedDoc = customers?.documents?.find((d) => d.documentType === doc.typeName)
                            const isUploading = uploadInProgress && index === uploadInProgressIndex
                            const documentStatus = uploadedDoc ? t("root:completed") : t("root:pending")
                            const handleExpiryDateChange = (value: Date, index: number) => {
                              const newExpiryDate = d.fromJSDate(value).endOf("day").toUTC().toISO();
                              const docType = sortedDocuments[index].typeName;

                              setExpiryDates((prevExpiryDates) => ({
                                ...prevExpiryDates,
                                [docType]: newExpiryDate,
                              }));

                              setDocuments((prevDocuments) => {
                                return (prevDocuments || []).map((doc) =>
                                  doc.documentType === docType ? { ...doc, expiryDate: newExpiryDate } : doc
                                );
                              });

                              setInputValues((prevState) => ({
                                ...prevState,
                                expiryDate: newExpiryDate,
                              }));
                            };

                            const renderUploadButton = () => {
                              const buttonContent = (
                                <span>
                                  <label
                                    htmlFor={`documentUpload${index}`}
                                    style={{
                                      cursor: doc.hasExpiry && !expiryDates[doc.typeName] ? "not-allowed" : "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span>
                                      {isUploading ? <CircularProgress size={20} thickness={5} /> : <CloudUploadIcon />}
                                    </span>
                                  </label>
                                  <input
                                    accept="image/jpg, image/jpeg, image/png, application/pdf"
                                    style={{ display: "none" }}
                                    disabled={!mdDown && (doc.hasExpiry && !expiryDates[doc.typeName])}
                                    onClick={(e) => {
                                      if (doc.hasExpiry && !expiryDates[doc.typeName]) {
                                        e.preventDefault();
                                        snackbar({
                                          message: t("snackBar:selectExpiryDateUpload"),
                                          variant: SnackBarVariant.ERROR
                                        });
                                        return;
                                      }
                                      setInputValues((prevState) => ({
                                        ...prevState,
                                        documentType: doc.typeName,
                                      }))
                                    }}
                                    onChange={(e: any) => {
                                      if (doc.hasExpiry && !expiryDates[doc.typeName]) {
                                        return;
                                      }
                                      uploadDocument(e, index)
                                      e.target.value = null
                                    }}
                                    id={`documentUpload${index}`}
                                    type="file"
                                  />
                                </span>
                              );

                              return mdDown ? (
                                <div>{buttonContent}</div>
                              ) : (
                                <Tooltip title={doc.hasExpiry && !expiryDates[doc.typeName] ? t("root:selectExpiryDateUpload") : ""}>
                                  {buttonContent}
                                </Tooltip>
                              );
                            };
                            const formattedCreatedAt = uploadedDoc?.createdAt ? new Date(uploadedDoc.createdAt).toLocaleDateString() : t("root:na")
                            return (
                              <TableRow key={index}>
                                <TableCell component="th" scope="row">
                                  {formattedCreatedAt}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  {doc.typeName}
                                </TableCell>
                                <TableCell align="left">
                                  {uploadedDoc ? uploadedDoc.documentName : t("root:na")}
                                </TableCell>
                                <TableCell align="left">{uploadedDoc && uploadedDoc.expiryDate ? getLocalizedDateFormat(country, uploadedDoc.expiryDate, DATE_TYPE.CONDENSED) : t("root:na")}
                                </TableCell>
                                {isVerificationPending && (
                                  <TableCell align="left">
                                    {doc.hasExpiry && (
                                      <FlatPickerBar
                                        identifier={`expiryDatePicker-${index}`}
                                        name={`expiryDate-${index}`}
                                        value={expiryDates[doc.typeName] || (uploadedDoc && sortedDocuments[index].expiryDate
                                          ? new Date(uploadedDoc.expiryDate).toISOString().substring(0, 10)
                                          : "")}
                                        placeholderValue={t("root:selectExpiryDate")}
                                        handleDateChange={(value: Date) => handleExpiryDateChange(value, index)}
                                        country={country}
                                        enableTime={false}
                                        minDate={getLocalizedDateFormat(country, d.now().toUTC().toISO(), DATE_TYPE.CONDENSED)}
                                        render={({ defaultValue, value, ...props }: any, ref: any) => (
                                          <input id={`expiryDateInput-${index}`} {...props} defaultValue={defaultValue} ref={ref} style={{ height: "30px", width: "120px" }} />
                                        )}
                                      />
                                    )}
                                  </TableCell>
                                )}
                                <TableCell align="left">{documentStatus}</TableCell>
                                <TableCell align="left">
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    {isVerificationPending ? renderUploadButton() : ""}
                                    {uploadedDoc && (
                                      <GetAppIcon
                                        style={{
                                          color: "blue",
                                          marginLeft: "10px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => downloadDocument(uploadedDoc.documentKey, uploadedDoc.documentName)}
                                      />
                                    )}
                                  </div>
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                )}
              </Grid>
              {open && (
                <ImageGallery
                  title={`${getLocalisedLicense(country)} ${"root:images"}`}
                  open={open}
                  handleClose={() => setOpen(false)}
                  images={
                    licenseImages && licenseImages.length > 0
                      ? licenseImages.map((image) => image["document"])
                      : []
                  }
                />
              )}
            </div>
            {editing && <div style={{ marginTop: 30 }}>
              <Button
                onClick={() => {
                  setEditing(false);
                  formikProps.resetForm();
                  setDocuments(customers.documents || [])
                  setNewlyAddedDocuments([])
                  setDocumentsMarkedForDeletion([])
                  setSelectedDocument(undefined)
                  setInputValues(defaultValues)
                  setExpiryDates({})

                }}
                variant="outlined"
                color="default" size="large"
                disableRipple
                style={{ textTransform: "initial", fontSize: 14, fontWeight: 500, padding: "6px 14px" }}
              >
                {t("misc:cancel")}
              </Button>
              <span className="margin-left"></span>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "var(--primary-color)",
                  textTransform: "initial",
                  boxShadow: "none",
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#fff"
                }}
                size="large"
                disableRipple
              >
                {t<string>("misc:save")}
              </Button>
            </div>}
          </Form>
        )}
      </Formik>

      <Dialog
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t("root:confirmDelete")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("root:documentDeleteConfirmMsg")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteModalOpen(false)} color="primary">
            {t('misc:cancel')}
          </Button>
          <Button onClick={confirmDeleteDocument} color="primary" autoFocus>
            {t('misc:delete')}
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
};

export default ProfileScreen;